import { render, staticRenderFns } from "./route-info.vue?vue&type=template&id=13be36ba&scoped=true&"
import script from "./route-info.vue?vue&type=script&lang=js&"
export * from "./route-info.vue?vue&type=script&lang=js&"
import style0 from "./route-info.vue?vue&type=style&index=0&id=13be36ba&lang=scss&scoped=true&"
import style1 from "./route-info.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13be36ba",
  null
  
)

export default component.exports